import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InitialExchanges, Pull } from './exchangesSliceTypes';

const initialState: InitialExchanges = {
    isSecondDrawerVisible: false,
    pullStatus: {},
    overallPnl: {},
    isRefreshError: false,
};

const slice = createSlice({
    name: 'exchanges',
    initialState,
    reducers: {
        toggleSecondDrawer: (state, action: PayloadAction<boolean>) => {
            state.isSecondDrawerVisible = action.payload;
        },
        resetExchangesState: (state) => {
            state.pullStatus = {};
            state.isSecondDrawerVisible = false;
            state.overallPnl = {};
            state.isRefreshError = false;
        },

        setPullStatus: (state, action: PayloadAction<Pull>) => {
            state.pullStatus[action.payload.apiKeyId] = action.payload;
        },
        resetPullStatus: (state, action: PayloadAction<number>) => {
            const statuses = { ...state.pullStatus };

            if (statuses?.[action.payload]) {
                delete statuses[action.payload];
                state.pullStatus = statuses;
            }
        },
        resetAllPullStatus: (state) => {
            state.pullStatus = {};
        },
        setOverallPnl: (state, action: PayloadAction<{ accountId: number; pnl: number }>) => {
            state.overallPnl[action.payload.accountId] = action.payload.pnl;
        },
        setRefreshError: (state, action: PayloadAction<boolean>) => {
            state.isRefreshError = action.payload;
        },
        clearRefreshError: (state) => {
            state.isRefreshError = false;
        },
    },
});

export const {
    toggleSecondDrawer,
    resetExchangesState,
    setPullStatus,
    resetPullStatus,
    resetAllPullStatus,
    setOverallPnl,
    setRefreshError,
    clearRefreshError,
} = slice.actions;
export default slice.reducer;
